<template>
  <PageWrapper>
    <template v-slot:content>
      <div class="custom-table">
        <el-button type="primary" size="small" class="el-icon-plus custom-btn" @click="handleAdd">新增供应商</el-button>
        <el-table border fit  highlight-current-row class="customer-table supplier-table" :data="list" v-loading="listLoading" >
          <el-table-column label="ID" prop="id"></el-table-column>
          <el-table-column label="供应商名称" prop="name"></el-table-column>
          <el-table-column label="联系人" prop="uname"></el-table-column>
          <el-table-column label="联系电话" prop="phone"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button type="primary" size="small" @click="handleEdit(scope)"
                         class="el-icon-edit-outline"
              >
                编辑
              </el-button>
              <el-popconfirm
                iconColor="red"
                @confirm="handleDelete(scope.row,scope.$index)"
                title="确认删除此条数据吗？"
              >
                <el-button slot="reference" type="danger" size="small" class="el-icon-delete">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                       :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]" :page-size="selectPage.pageSize"
                       background
                       layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                       style="margin-top: 14px;margin-bottom:14px"
        >
        </el-pagination>
      </div>
      <Edit :dialog="dialog" :form-data="editFormData"  @submit="handleSubmit" :type="type" @close="handleClose" />
    </template>
  </PageWrapper>
</template>
<script>
import { computed, defineComponent, onMounted, reactive, ref } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue';
import Edit from "./edit.vue";
import request from '@/utils/request';
import { Message } from 'element-ui';

export default defineComponent({
  components: {PageWrapper,Edit},
  setup() {
    const showAll = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20,
    })
    const allNum = ref(1)
    const dialog = ref(false)
    const type = ref("")
    const editFormData = ref({})
    const list = ref([])
    const keyId = ref(null)

    const word = computed(()=>{
      if(!showAll.value){
        return '展开'
      }else{
        return '收起'
      }
    })
    const handleAdd = () => {
      dialog.value = true;
      type.value = "add";
      editFormData.value = {}
    }
    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getSupplier()
    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getSupplier()
    }

    const closeSearch = () => {
      showAll.value = !showAll.value
    }

    const handleSearchBtn = () => {
      selectPage.pageNum = 1
    }

    const handleEdit = (scope) => {
      dialog.value = true
      type.value = "edit"
      const {name,phone,uname,id} = scope.row
      keyId.value = id
      editFormData.value = {name, phone,uname}

    }

    const handleDelete = (scope, index) =>{
      request({
        url: 'supplier_delete.yy',
        method: 'post',
        data: { id: scope.id }
      }).then(res =>{
        if(res.code == 200) deleteRow(index)
      }).catch(err =>{
        Message({message: err,type: 'error'})
      })
    }

    const deleteRow = (index)=> {
      list.value.splice(index, 1)
    }

    onMounted(() => {
      getSupplier()
    })

    const listLoading = ref(false)
    listLoading.value = true
    const getSupplier = () => {
      request({
        url: 'supplier_list.yy',
        params: selectPage,
        method: 'post',
      }).then((res) => {
        const {code, data,total} = res
        if(code == 200) {
          listLoading.value = false
          list.value = data
          allNum.value = total
        }
      })
    }

    const handleSubmit = (form) => {
      let data;
      if(type.value === 'add') {
        data = request({
          url: 'supplier_add.yy',
          method: 'post',
          data: form
        })
      }else{
        data = request({
          url: 'supplier_update.yy',
          method: 'post',
          data: {id: keyId.value,...form}
        })
      }
      data.then(res=>{
        if(res.code == 200){
           dialog.value = false
           getSupplier()
        }
      })
    }

    const handleClose = () => {
      dialog.value = false
      editFormData.value = {}
    }

    return {
      listLoading,
      showAll,
      dialog,
      editFormData,
      type,
      allNum,
      selectPage,
      word,
      list,
      keyId,
      handleClose,
      handleAdd,
      pageSizeChange,
      pageCurrentChange,
      handleSubmit,
      closeSearch,
      handleSearchBtn,
      handleEdit,
      handleDelete,
      deleteRow
    };
  }
})
</script>
<style scoped>
.el-icon-edit-outline {
  margin-right: 10px;
}
.el-icon-delete {
  span {
    margin-left: 4px;
  }
}
</style>

